import React, { useCallback } from 'react';
import classnames from 'clsx';

/**
 * @typedef {import('./dropdown-types.d.ts').DropdownTogglerComponent} DropdownTogglerComponent
 */

/**
 * @type {DropdownTogglerComponent}
 */
export const DropdownToggler = React.forwardRef(({ children, id, isOpen, onBlur, onClose, onFocus, onOpen, openTogglerClassName }, ref) => {
  const child = /** @type {JSX.Element} */ (React.Children.only(children));
  const { onClick } = child.props;

  const handleClick = useCallback(
    (e, ...args) => {
      if (!onClick) {
        e.preventDefault();
      }

      if (isOpen) {
        onClose(e);
      } else {
        onOpen(e, ...args);
      }

      if (onClick) {
        onClick(e);
      }
    },
    [onClick, isOpen, onClose, onOpen],
  );

  const props = {
    id,
    onBlur,
    onClick: handleClick,
    onFocus,
    className: classnames(child.props.className, 'dropdown-toggler', {
      [openTogglerClassName]: isOpen,
    }),
    isOpen,
    ref,
  };

  // If this is a host component (e.g. 'div', 'span', etc) remove invalid html attribute props
  if (typeof child.type === 'string') {
    delete props.isOpen;
  }

  return React.cloneElement(child, props);
});

DropdownToggler.displayName = 'DropdownToggler';
